import React, { Component } from 'react';
import { Mood, SentimentSatisfied } from '@material-ui/icons';
import { IconCard } from '../basic_items';



class DashboardIconCard extends Component {
  render() {
    let item=this.props.data||{};
    let config=item.widget_config||{};
    let data=item.widget_data||{};
    return (
      <IconCard
      title={data.value}
      subtitle={item.widget_title}
      type={config.type}
      style={{
        height: '100%',
        // width:'100%'
      }}
      parentStyle={{
        flex: 1,
        margin:8
      }}
      icon={string_to_icon[config.icon]}
      // link='/dashboard/pending'
      />
    );
  }
}

export default DashboardIconCard;

const string_to_icon={
  "HAPPY":<Mood/>,
  "SAD":<SentimentSatisfied/>
}